module.exports = __webpack_public_path__ + "img/07e7c73.jpg";